"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imageDocument = void 0;
exports.imageDocument = {
    type: "machineImage",
    name: "machineImage",
    label: "documents.image.label",
    subline: "documents.image.subline",
};
exports.default = exports.imageDocument;
